export default {
  'menu.CompanyDetailPage': '场所详情页',
}